import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bac7887"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = { class: "modal__container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "player",
  class: "youtube"
}, null, -1))
const _hoisted_4 = ["src"]

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useModal, useInfo } from '@/store';
import { onUpdated } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'TheModal',
  setup(__props) {

_useCssVars(_ctx => ({
  "5f98d193": (_unref(bg).pc),
  "58988442": (_unref(bg).mobile),
  "4614489c": (_unref(playButton).pc),
  "45c4060c": (_unref(playButtonActive).pc),
  "438f17cf": (_unref(closeButton).mobile),
  "92514390": (_unref(modalFrame).pc),
  "c2739332": (_unref(modalFrame).mobile)
}))

const { isOpen, isPlaying, cover, youtube } = storeToRefs(useModal());
const { openModal, playVideo, setCover, setYoutube } = useModal();

const tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
const firstScriptTag: any = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

let player: any;
function play() {
  playVideo(true);
  player.playVideo();
}
function close() {
  playVideo(false);
  openModal(false);
  setCover('');
  setYoutube('');
  player.stopVideo();
  player = undefined;
}
async function onPlayerReady(event: any) {
  event.target.playVideo();
  playVideo(true);
}
let timeout: any = null;
function onPlayerStateChange(event: { [key: string]: any }) {
  if (event.data === window.YT.PlayerState.PAUSED) {
    timeout = setTimeout(() => playVideo(false), 300);
  }
  if (event.data === window.YT.PlayerState.BUFFERING) {
    clearTimeout(timeout);
  }
  if (event.data === window.YT.PlayerState.PLAYING) {
    clearTimeout(timeout);
  }
  if (event.data === window.YT.PlayerState.ENDED) {
    player.stopVideo();
    playVideo(false);
  }
}
function onYouTubeIframeAPIReady(id: string) {
  player = new window.YT.Player('player', {
    height: '390',
    width: '640',
    videoId: id,
    playerVars: {
      playsinline: 1,
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerStateChange,
    },
  });
}

onUpdated(() => {
  if (isOpen.value && player === undefined) {
    onYouTubeIframeAPIReady(youtube.value);
  }
});

const { getImg } = useInfo();
const bg = computed(() => ({
  pc: `url(${getImg('home_pc_modal_mask')})`,
  mobile: `url(${getImg('home_mobile_modal_mask')})`,
}));
const playButton = computed(() => ({
  pc: `url(${getImg('home_pc_play')})`,
}));
const playButtonActive = computed(() => ({
  pc: `url(${getImg('home_pc_play_active')})`,
}));
const closeButton = computed(() => ({
  mobile: `url(${getImg('home_mobile_modal_close')})`,
}));
const modalFrame = computed(() => ({
  pc: `url(${getImg('home_pc_modal_frame')})`,
  mobile: `url(${getImg('home_mobile_modal_frame')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_unref(isOpen))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "close",
            type: "button",
            onClick: close
          }),
          _createElementVNode("div", {
            class: _normalizeClass(["content", { 'content--playing': _unref(isPlaying), 'content--cover': !_unref(isPlaying) }])
          }, [
            _hoisted_3,
            (!_unref(isPlaying))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "cover",
                  src: _unref(cover),
                  alt: ""
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            (!_unref(isPlaying))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "play",
                  type: "button",
                  onClick: play
                }))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})